const webComponentTags = new Map<string, string>();

/** Composition root: registers the main-region custom element for a `pageId`. */
export function registerShellMainWebContent(pageId: string, customElementTag: string): void {
  webComponentTags.set(pageId, customElementTag);
}

export function getShellMainWebContentTag(pageId: string): string {
  const tag = webComponentTags.get(pageId);
  if (!tag) {
    throw new Error(`Shell main page (web) not registered: ${pageId}`);
  }
  return tag;
}

/** Tests only: clears the registry between cases. */
export function resetShellMainPageRegistryForTests(): void {
  webComponentTags.clear();
}
